import Api from "./Api";

export default {
  async getDeviceData() {
    try {
      let response = await Api({
        url: "/user/device/",
        method: "get"
      });
      return response
    }catch (e) {
      new Error('Server not responding !');
    }
  },

  async newState(data) {
    try {
      let response = await Api({
        url: "/user/device/states",
        data: data,
        method: "post"
      });
      return response
    } catch (err) {
      throw new Error('Server not responding !');
    }

  },

  async getDeviceStats(data) {
    try {
      let response = await Api({
        url: "/user/device/stats/" + data.startDateTime + "/" + data.endDateTime,
        method: "get"
      });
      return response
    }catch (err) {
      throw new Error('Server not responding !');
    }

  }

};
